import { isEmpty } from 'lodash';
import patch from './patch';
import computeAverageFootprint from './computeAverageFootprint';
import { parseLocationModesToLocation, displayLocation } from '../../lib/locations';
import { handleUnexpectedError } from './handleUnexpectedError';

const makeAverageComparisonLocation = (calcApiLocation, availableLocation) => {
  if (isEmpty(availableLocation)) return undefined;
  return displayLocation(parseLocationModesToLocation(calcApiLocation));
};

/**
 * selectLocation - Uses the place_id returned from Google Maps
 * places autocomplete call to get the geocode details. This is then
 * sent to calculators API to see what level of location data it supports.
 * We then support the most location level possible.
 * @param {Object} locationSuggestion
 * @param {String} locationSuggestion.description
 * @param {String} locationSuggestion.key
 * @param {String} locationSuggestion.city
 * @param {String} locationSuggestion.state
 */
export default locationSuggestion => async (dispatch, getState) => {
  let availableLocationModes = {};
  let locationModes = null;
  try {
    // console.log(locationSuggestion);
    if (locationSuggestion !== null) {
      const params = {
        input_location: locationSuggestion.key,
        input_location_country: locationSuggestion.country,
        input_location_mode: locationSuggestion.input_location_mode,
      };
      availableLocationModes = {
        1: locationSuggestion.key,
        5: 'US',
      };
      locationModes = {
        1: locationSuggestion.key,
        2: locationSuggestion.city,
        4: locationSuggestion.state,
        5: 'US',
      };
      dispatch(patch({
        ui: { averageComparisonLocation:
          makeAverageComparisonLocation(locationModes, availableLocationModes),
        },
      }));
      computeAverageFootprint(params)(dispatch, getState);
    }
  } catch (err) {
    handleUnexpectedError(err)(dispatch, getState);
  }
};
